namespace Matrix.Data {
    export class RowCustomizationColumns {
        static columnsKey = 'Data.RowCustomization';
    }
}
